import React from 'react';
import { motion } from 'framer-motion';

interface StatusTab {
  key: string;
  label: string;
  count: number;
  color: string;
}

interface UserOrdersStatusTabsProps {
  statusFilter: string;
  onStatusFilterChange: (status: string) => void;
  getStatusCount: (status: string) => number;
  totalCount: number;
  favoritesCount?: number;
}

const UserOrdersStatusTabs: React.FC<UserOrdersStatusTabsProps> = ({
  statusFilter,
  onStatusFilterChange,
  getStatusCount,
  totalCount,
  favoritesCount = 0,
}) => {
  const tabs: StatusTab[] = [
    { key: 'all', label: 'Tümü', count: totalCount, color: 'gray' },
    { key: 'pending', label: 'Bekliyor', count: getStatusCount('pending'), color: 'yellow' },
    { key: 'preparing', label: 'Hazırlanıyor', count: getStatusCount('preparing'), color: 'blue' },
    { key: 'on-the-way', label: 'Yolda', count: getStatusCount('on-the-way'), color: 'purple' },
    { key: 'completed', label: 'Tamamlandı', count: getStatusCount('completed'), color: 'green' },
    { key: 'cancelled', label: 'İptal', count: getStatusCount('cancelled'), color: 'red' },
    { key: 'favorites', label: 'Favorilerim', count: favoritesCount, color: 'pink' },
  ];

  const getTabClasses = (tab: StatusTab) => {
    const isActive = statusFilter === tab.key;
    const baseClasses = 'px-4 py-2 rounded-full text-sm font-medium transition-colors duration-150';

    if (isActive) {
      switch (tab.color) {
        case 'yellow':
          return `${baseClasses} bg-yellow-500 text-white`;
        case 'blue':
          return `${baseClasses} bg-blue-500 text-white`;
        case 'purple':
          return `${baseClasses} bg-purple-500 text-white`;
        case 'green':
          return `${baseClasses} bg-green-500 text-white`;
        case 'red':
          return `${baseClasses} bg-red-500 text-white`;
        case 'pink':
          return `${baseClasses} bg-pink-500 text-white`;
        default:
          return `${baseClasses} bg-gray-500 text-white`;
      }
    } else {
      switch (tab.color) {
        case 'yellow':
          return `${baseClasses} bg-white text-yellow-600 hover:bg-yellow-50 border border-yellow-200`;
        case 'blue':
          return `${baseClasses} bg-white text-blue-600 hover:bg-blue-50 border border-blue-200`;
        case 'purple':
          return `${baseClasses} bg-white text-purple-600 hover:bg-purple-50 border border-purple-200`;
        case 'green':
          return `${baseClasses} bg-white text-green-600 hover:bg-green-50 border border-green-200`;
        case 'red':
          return `${baseClasses} bg-white text-red-600 hover:bg-red-50 border border-red-200`;
        case 'pink':
          return `${baseClasses} bg-white text-pink-600 hover:bg-pink-50 border border-pink-200`;
        default:
          return `${baseClasses} bg-white text-gray-600 hover:bg-gray-50 border border-gray-200`;
      }
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3, delay: 0.1 }}
      className="mb-8"
    >
      <div className="flex flex-wrap gap-3 mb-6">
        {tabs.map(tab => (
          <button
            key={tab.key}
            onClick={() => onStatusFilterChange(tab.key)}
            className={getTabClasses(tab)}
          >
            {tab.label} ({tab.count})
          </button>
        ))}
      </div>
    </motion.div>
  );
};

export default UserOrdersStatusTabs;
